export default {
    state: {
        courses: [],
        coursesNextUrl: undefined,

        myCourses: [],
    },
    mutations: {
        ADD_COURSES(state, payload){
            state.courses.push(...payload.data);
            state.coursesNextUrl = payload.next;
        },
        SET_COURSES(state, payload){
            state.courses = payload.data;
            state.coursesNextUrl = payload.next;
        },
        UPDATE_COURSE(state, payload){
            state.courses = state.courses.map(course=>{
                if (course.id === payload.data.id){
                    course = Object.assign(course, payload.data);
                }
                return course;
            })
        },
        SET_MY_COURSES(state, payload){
            state.myCourses = payload.data;
        },
        ADD_TO_MY_COURSES(state, payload){
            state.myCourses.push(...payload.data);
        },

    },
    actions: {
        loadWalletData({commit}, payload){
            const url = payload.url || '/wallet';
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    const wallet = response.data.wallet;
                    if (wallet && wallet.balance){
                        commit('SET_USER_BALANCE', wallet.balance);
                    }
                    resolve(response)
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        transferBalance({state, commit}, payload){
            const url = '/wallet/transfer';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    commit('SET_USER_BALANCE', response.data.balance);
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        rechargeByMobileWallets({commit}, payload){
            const url = '/wallet/recharge/mobile-wallet';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        rechargeByRechargeCard({commit}, payload){
            const url = '/wallet/recharge/recharge-card';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobCardOrder({commit}, payload){
            const url = '/wallet/paymob/order/card';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobMobileWalletOrder({commit}, payload){
            const url = '/wallet/paymob/order/mobile-wallet';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobKioskOrder({commit}, payload){
            const url = '/wallet/paymob/order/kiosk';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },
        createPaymobValuOrder({commit}, payload){
            const url = '/wallet/paymob/order/valu';

            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                });
            });
        },

    }
}